export const ELEMENTS: any = {
    contour:[],
    zones:[]
}

export const ZONES_TYPES:any = [
    // {val:0,name:'Other'},
    {val:1,name:'Acoustic'},
    {val:2,name:'Balcony/Terrace'},
    {val:3,name:'Plant/PV'},
    {val:4,name:'Thermal only'},
    {val:5,name:'Walkway'}
]

